import React, { useState, useEffect } from "react";
import { poCount, finalizePO, cancelPO, allPOs, getPOsForSubsite, currentFilter, setFilter, oosError, finalizeStatus, latestPOId } from '../../../reducers/purchaseorder';
import { getOrdersForSubsite, allOrders, orderCount } from '../../../reducers/orders';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import MSMPagination from '../../MSMPagination';
import { useLocation } from "react-router-dom";
import AdminService from "../../../services/admin.service";
import PurchaseOrderService from "../../../services/purchaseorder.service";
import DecoratorService from "../../../services/decorator.service";
import { Container, Row, Col } from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import { getUserCapabilities, getSubsite } from '../../../reducers/auth';
import { resolveImageUrl } from '../../../utils/imageUrl';

const AdminPurchaseOrders = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const pos = useSelector(allPOs);
  const poCnt = useSelector(poCount);
  const poStatus = useSelector(state => state.purchaseorders.status);
  const currentFlt = useSelector(currentFilter);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(0);
  const [resetPagination, setResetPagination] = useState(false);
  const orderStatus = useSelector(state => state.orders.status);
  const finalStatus = useSelector(finalizeStatus);
  const latestPO = useSelector(latestPOId);  
  const orderCnt = useSelector(orderCount);
  const oos = useSelector(oosError);
  const [link, setLink] = useState(null);
  const [showLinkButton, setShowLinkButton] = useState(false);
  const [activeDecoratorId, setActiveDecoratorId] = useState(0);

  const [orders, setOrders] = useState([]);
  const [decorators, setDecorators] = useState([]);
  const [showNHKOnly, setShowNHKOnly] = useState(false);
  const currentSubsite = useSelector(getSubsite);

  useEffect(() => {
    async function fetchData() {
      var response = await PurchaseOrderService.getApprovedOrders(showNHKOnly);
      setOrders(response.data);
      const decorators = await DecoratorService.getDecorators();
      setDecorators(decorators);
      setActiveDecoratorId(decorators[0].id);
    }
    fetchData();
  }, [showNHKOnly]);
  
  const cancelOrderClick = () => {
    dispatch(cancelPO(cancelOrderId));
    setShow(false);
  }

  const finalizeOrderClick = (event, poId) => {
    event.target.disabled = true;

    dispatch(finalizePO(poId));
  }

  const filterChanged = (event) => {
    console.log(event.target.value);
    setFilter(event.target.value);
    setResetPagination(!resetPagination);
  }

  const reloadData = async(range) => {
    var response = await PurchaseOrderService.getApprovedOrders();
    setOrders(response.data);
  //const params = [ finalized, range[0], range[1] ];
    //dispatch(getPOsForSubsite(params));
  }
  
  const setDecorator = (event) => {
    setActiveDecoratorId(event.target.value);
  }

  const finalizePo = async () => {
    console.log("Getting XLS Report");
    // Get the IDs of the orders currently displayed
    const orderIds = orders.map(order => order.id);
    if (orderIds.length === 0) {
      alert("No orders to finalize");
      return;
    }
    const result = await dispatch(finalizePO({decoratorId: activeDecoratorId, orderIds: orderIds}));
    if (result.payload?.data?.poId) {
      setLink("http://localhost:5000/api/admin/purchaseorder/report/" + result.payload.data.poId);
      // Remove finalized orders from the list
      setOrders([]);
      navigate("/admin/closedpos");
    }
  }
  const handleClose = () => setShow(false);

  const downloadPO = async (id) => {
    console.log("Downloading PO");
    var status = await AdminService.downloadPO(id);
  }
  var orderContent = [];
  return (
    <>
    <h1>Current Batch</h1>
    {showLinkButton && <Button onClick={() => downloadPO(latestPO)}>Download PO</Button>}
    <div className="total">
        <Button onClick={() => {finalizePo() }}>Finalize Batch</Button>
          {orderContent}
        </div>
        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          <Form.Check
            type="checkbox"
            id="showNHKOnly"
            label="Show only New Hire Kits"
            checked={showNHKOnly}
            onChange={(e) => setShowNHKOnly(e.target.checked)}
            style={{ display: 'inline-block', marginRight: '20px' }}
          />
          <select onChange={setDecorator} >
            {decorators && decorators.map(decorator => (
              <option value={decorator.id} key={decorator.id}>{decorator.name}</option>
            ))}
          </select>
        </div>
    {orders.length > 0 && orders.map(order => {
        let total = 0;
        let totalCount = 0;
        let items = [];
        console.log(order);
        order.order_items.map(item => {
          // Print item: stored price is the line total (see addPrintItemToOrder)
          const isPrintItem = item.printItemId && item.print_item;
          if (isPrintItem) {
            total += item.price;
          } else {
            total += (item.price * item.quantity);
          }
          totalCount += item.quantity;

          if (isPrintItem) {
            const pi = item.print_item;
            const piImage = pi.imageUrl
              ? (pi.imageUrl.includes('uploads') ? apiUrl + pi.imageUrl : pi.imageUrl)
              : null;
            items.push(
              <div className="adminOrder">
                <Container fluid>
                  <Row>
                    <Col>
                      {piImage && <img src={piImage} height={'50'}></img>}
                    </Col>
                    <Col xs={6}>
                      {pi.title}
                    </Col>
                    <Col className="color"></Col>
                    <Col className="size-name"></Col>
                    <Col className="quantity">
                      {item.quantity}
                    </Col>
                    <Col className="price">
                      {(item.price).toLocaleString(undefined, { style: "currency", currency: "USD"})}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {(item.order_item_personalizations || []).map((p, idx) => (
                        <div key={idx}>{p.fieldName}: {p.fieldValue}</div>
                      ))}
                    </Col>
                  </Row>
                </Container>
              </div>);
            return;
          }

          items.push(
          <div className="adminOrder">
                              <Container fluid>
                                <Row>
                                  <Col>
                                    <img src={resolveImageUrl(item.product?.frontModelImage)} height={'50'}></img>
                                  </Col>
                                  <Col xs={6}>
                                    {item.product?.style.title}
                                  </Col>
                                  <Col className="color">
                                  {item.colorName}
                                  </Col>
                                  <Col className="size-name">
                                  {item.sizeName}
                                  </Col>
                                  <Col className="quantity">
                                  {item.quantity}
                                  </Col>
                                  <Col className="price">
                                  {(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD"})}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    {item.subsite_decos?.map(logo => {
                                      console.log("LOGO IN DECORATION", logo);
                                      return logo.decoration_logo.decorationName + " - " + logo.deco_location.description;
                                    })}
                                  </Col>
                                </Row>
                              </Container>
          </div>);
        });
        return (
        <div className="admin-order-container">
                      {order.newHireKit && currentSubsite.paymentOptions !== "kit" && (
              <div className="header" style={{ backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >New Hire Kit</span>
              </div>
            )}
            {order.newHireKit && currentSubsite.paymentOptions === "kit" && (
              <div className="header" style={{ backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >Kit Order</span>
              </div>
            )}
            {order.polybag && (
              <div className="header" style={{ borderRadius: 0, backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >Polybag Label: {order.polybagLabel}</span>
              </div>
            )}
            <div className="header">
                <div><span className="caption">Date Placed</span><br />{new Date(order.placed).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }</div>
                <div><span className="caption">Total</span><br />{(order.chargedToCC + order.balanceUsed).toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</div>
                <div><span className="caption">Delivery Name</span><br />{order.deliveryName}</div>
                <div><span className="caption">Balance</span><br />{order.balanceUsed}</div>
                <div><span className="caption">Ordered By</span><br />{order.orderedBy?.lastname}, {order.orderedBy?.firstname}</div>
                <div><span className="caption">Order #</span><br />{order.id}</div>
                <div><span className="caption">Status</span><br />{order.status.toUpperCase()}</div>
            </div>
            <div>
              {items}
            </div>
            <div className="total">Shipping: <strong>{order.shippingCost?.toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong><br />
            Balance Used: <strong>{order.balanceUsed?.toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong><br />
            Charged to CC: <strong>{parseFloat(order.chargedToCC).toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong><br />
            Total ({totalCount} items): <strong>{(order.chargedToCC + order.balanceUsed).toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong></div>
        </div>
        );
    })}

    {orders.length == 0 && (
        <div>No Orders</div>
    )
    }
        <div className="total">
        <Button onClick={() => {finalizePo() }}>Finalize Batch</Button>
          {orderContent}
        </div>
    
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel Order # {cancelOrderId} </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancelOrderClick}>
            Cancel the Order
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};
export default AdminPurchaseOrders;

